<template>
    <div>
        <breadcrumbs
            :title="'Vrste podtema'"
            :breadcrumbs="breadcrumbs"
        ></breadcrumbs>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Vrsta podteme: {{ naziv }}</h5>
            </div>
            <div class="ibox-content">
                <vrsta-teme2-forma
                    :disabled="true"
                    :id="id"
                    :modal="false"
                    :action="'show'"
                    @returnData="setData"
                ></vrsta-teme2-forma>
            </div>
        </div>
    </div>
</template>

<script>
import Breadcrumbs from "../../../../components/breadcrumbs/Breadcrumbs";
import VrstaTeme2Forma from "./VrstaTeme2Forma";
export default {
    name: "VrstaTema2Details",
    components: {
        VrstaTeme2Forma,
        Breadcrumbs
    },
    data(){
        return {
            id: this.$route.params.vrsta_teme2_id,
            breadcrumbs: [],
            naziv: ''
        }
    },
    methods: {
        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/postavke/vrste-tema2',
                    name: 'Vrste podtema'
                },
                {
                    path: '/postavke/vrste-tema2/' + this.id,
                    name: 'Vrsta podteme: ' + this.naziv
                }
            ]
        },
        setData( data ){
            this.naziv = data.naziv || ''
            this.setBreadcrumbs()
        }
    }
};
</script>

<style scoped>

</style>
